import clsx from 'clsx';
import styles from 'components/UI/V3/Table/Header/TableHeader.module.scss';
import React from 'react';

type TableHeaderProps = React.ComponentProps<'thead'>;

export const TableHeader: React.FC<TableHeaderProps> = ({ children, className, ...props }) => {
    return (
        <thead
            className={clsx(styles.root, className)}
            {...props}
        >
            <tr>{children}</tr>
        </thead>
    );
};
